import React, { Fragment } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

import PageHead, { PageHeading, PageHeadRight } from 'Layout/PageHead'
import PageContent from 'Layout/PageContent'
import PageTabs, { PageTab, PageTabList } from 'Layout/PageTabs'

import Users from './Users'
import InviteUser from './Users/InviteUser'
import AccountSettings from './AccountSettings'
import ContentSettings from './ContentSettings'
import { useGetMyDataQuery } from 'Services/me'
import Authorized from '../../../components/Authorized'

const ROUTE_PERMISSIONS = {
  users: ['user_read'],
  settings: ['account_settings_modify']
}

const Fallback = (props) => {
  const { paths = [] } = props
  const { data: user } = useGetMyDataQuery()

  const fallbackPath = paths.find((path) => {
    return ROUTE_PERMISSIONS[path].every((permission) => user.permissions.includes(permission))
  })

  return <Navigate to={fallbackPath ?? '/b'} replace />
}

const ManageAccounts = () => {
  return (
    <Fragment>
      <PageHead>
        <PageHeading>Manage Account</PageHeading>
        <PageHeadRight>
          <Routes>
            <Route path='users' exact element={<InviteUser />} />
          </Routes>
        </PageHeadRight>
      </PageHead>
      <PageContent>
        <PageTabs>
          <PageTabList>
            <Authorized permissions={ROUTE_PERMISSIONS.settings}>
              <PageTab to='settings' title='Account Settings' />
            </Authorized>
            <Authorized permissions={ROUTE_PERMISSIONS.users}>
              <PageTab to='users' title='Users' />
            </Authorized>
            <Authorized permissions={ROUTE_PERMISSIONS.settings}>
              <PageTab to='content-settings' title='Content Settings' />
            </Authorized>
          </PageTabList>
          <Routes>
            <Route path='settings' element={<AccountSettings />} />
            <Route path='users' element={<Users />} />
            <Route path='content-settings' element={<ContentSettings />} />
            <Route path='*' element={<Fallback paths={['settings', 'users']} />} />
          </Routes>
        </PageTabs>
      </PageContent>
    </Fragment>
  )
}

export default ManageAccounts
